export const filterOutNonViewableFields = (
  fields: [string, any][]
): [string, any][] => {
  return fields.filter(([_, { key, value }]) => !key.startsWith('/__'));
};

export const filterOutStandardQueryFields = (fields: [string, any][]) => {
  return fields.filter(
    ([_, { key, value }]) =>
      ![
        'fullUrl',
        'scheme',
        'host',
        'domain',
        'localpath',
        'autoupdater_nonce'
      ].includes(key)
  );
};
